<div class="registration-popup">
	<h2 class="text-center" id="FPWModalLabel">Forgot Password?</h2>
	<span class="hint-text text-center mg-btm-32">To receive instructions on resetting your password, enter the email you signed up with.</span>
	<app-alert [alertService]="alertService"></app-alert>
	<form role="form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
		<div class="form-group">
      <label for="email">Email Address</label>
      <input  type="text"
              class="form-control"
              id="email"
              formControlName="email"
              placeholder="Enter email" #emailInput/>

      <app-validation-message [control]="form.controls.email" class="form-error"></app-validation-message>
		</div>
		<button type="submit" class="btn wb-btn-default center-block  send-reset-email-btn" [disabled]="loading || notReady">
			Send Reset Email
			<img alt="reset email" *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
		</button>
	</form>
	<div class="text-center mg-top-24 mg-btm-9">
		<span role="button" (click)="childClosed()" class="forget-sign-link"> Sign In Later</span>
	</div>
	<span class="hint-text2 text-center mg-btm-9">Ordering & Rewards will be limited.</span>
</div>
